import { Component, ITemplateContext } from "@eusoft/webapp-core";
import { SongView } from "../songView/SongView";
import { forModel } from "@eusoft/webapp-jsx";
import { SliceBar } from "./SliceBar";
import "./SongViewHost.scss";

export class SongViewHost extends Component {

    constructor() {
        super();

        this.songView = new SongView();

        this.init(SongViewHost, {
            template: forModel<this>(m => <div className="song-view">
                <div className="group">
                    <div className="container" />
                    <SliceBar ref={m.vBar} orientation="vertical" />
                </div>
                <SliceBar ref={m.hBar} orientation="horizonatal" />
            </div>)
        });
    }

    override mount(ctx: ITemplateContext) {

        const songView = this.songView;

        songView.attach(ctx.element.querySelector(".container"));

        let suspendUpdate = 0;

        songView.addEventListener("viewChanged", () => {

            suspendUpdate++;

            const max = songView.getMaxViewRect();
            this.vBar.min = max.y;
            this.vBar.max = max.y + max.height;
            this.vBar.value = songView.origin.y;
            this.vBar.sliceSize = songView.viewRect.height;

            this.hBar.min = max.x;
            this.hBar.max = max.x + max.width;
            this.hBar.value = songView.origin.x;
            this.hBar.sliceSize = songView.viewRect.width;

            suspendUpdate--;
        });

        this.vBar.onChanged("value", v => {
            if (suspendUpdate)
                return;
            songView.origin.y = v;
            songView.updateTransform("view");
        });

        this.vBar.onChanged("sliceSize", v => {
            if (suspendUpdate)
                return;
            const viewSize = songView.getViewSize();
            songView.pixelPerHertz = viewSize.height / v;
        });

        this.hBar.onChanged("value", v => {
            if (suspendUpdate)
                return;
            songView.origin.x = v;
            songView.updateTransform("view");
        });

        this.hBar.onChanged("sliceSize", v => {
            if (suspendUpdate)
                return;
            const viewSize = songView.getViewSize();
            songView.pixelPerSeconds = viewSize.width / v;
        });
    }

    vBar: SliceBar;

    hBar: SliceBar;

    songView: SongView;
}